import React, { Component } from 'react'
import { Breadcrumb ,Input} from 'antd';
import './Header.css'

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state={
            searchValue:'',//记录需要搜索的值
        }
    }

    inputValueChange = (event) => {
        // console.log(event.target.value)
        if (!event.target.value) {
            this.props.searchTheNewsOrNotice(event.target.value)
            this.setState({
                searchValue:''
            })
        } else {
            this.setState({
                searchValue: event.target.value
            })
        }
        // console.log(event.target.value)
    }

    searchTheValue = () => {
        this.props.searchTheNewsOrNotice(this.state.searchValue)
    }

    render() { 
        return (
            <div>
                <div id='bread'>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <a href="#">首页</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                       新闻公告
                       </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div id='searchBox'>
                    <Input type='search' className={'WDsearch'} placeholder='请输入' onChange={(event)=>{this.inputValueChange(event)}}/>
                    <button className='search_button' onClick={()=>this.searchTheValue()}>搜索</button>
                </div>
            </div>
        )
    }
}
